module.exports = __webpack_public_path__ + "static/media/edge-logo.60bcb23f.png";